/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceAuditProblemFault {
  Customer = "customer",
  Carrier = "carrier",
  Freightsimple = "freightsimple",
  Unknown = "unknown",
}

export function instanceOfInvoiceAuditProblemFault(value: any): boolean {
  for (const key in InvoiceAuditProblemFault) {
    if (Object.prototype.hasOwnProperty.call(InvoiceAuditProblemFault, key)) {
      if (
        InvoiceAuditProblemFault[
          key as keyof typeof InvoiceAuditProblemFault
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceAuditProblemFaultFromJSON(
  json: any,
): InvoiceAuditProblemFault {
  return InvoiceAuditProblemFaultFromJSONTyped(json, false);
}

export function InvoiceAuditProblemFaultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemFault {
  return json as InvoiceAuditProblemFault;
}

export function InvoiceAuditProblemFaultToJSON(
  value?: InvoiceAuditProblemFault | null,
): any {
  return value as any;
}

export function InvoiceAuditProblemFaultToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemFault {
  return value as InvoiceAuditProblemFault;
}
